module.exports = __webpack_public_path__ + "img/zrcc.baf4fa27.png";